import { denormalize, normalize } from 'normalizr'
import { useSelector } from 'react-redux'
import api from '../../api'
import createSlice from '../create-slice'
import { featureFlagsSchema } from '../normalizr'
import { getEntities } from './entities'

const initialState = {
  featureFlagsIds: [],
  error: null,
}

const featureFlagsSlice = createSlice({
  name: 'featureFlags',
  initialState,
  reducers: {
    setFeatureFlags: (state, { payload }) => {
      state.featureFlagsIds = payload.result
    },
    setError: (state, { payload }) => {
      state.error = payload
    },
  },
})

const { actions } = featureFlagsSlice

const selectState = state => state[featureFlagsSlice.name]

export function useFeatureFlags() {
  const { featureFlagsIds } = useSelector(selectState)
  const entities = useSelector(getEntities)
  const featureFlags = denormalize(
    featureFlagsIds || [],
    [featureFlagsSchema],
    entities,
  )
  return featureFlags
}

export function fetchFeatureFlags() {
  return async dispatch => {
    try {
      const response = await api.featureFlags.list()
      dispatch(
        actions.setFeatureFlags({
          ...normalize(response, [featureFlagsSchema]),
        }),
      )
    } catch (error) {
      dispatch(actions.setError(error.message))
    }
  }
}

export function addFeatureFlag(data) {
  return api.featureFlags.create(data)
}

export function deleteFeatureFlag(id) {
  return api.featureFlags.delete(id)
}

export default featureFlagsSlice
